import React, { useEffect, useState } from "react";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  validatePAN,
  validateAadhaar,
  validatePassport,
  validateAlphabetsAndSpace,
} from "../../Helper/common";
import {
  getNIDDetails,
  uploadFileViaMultipartNID,
  saveNIDDetails,
  removeUploadedFile,
  deleteSaveNIDDetails,
  getNIDDetailsWithOCR,
  savePan,
  deleteSavePanDetails,
} from "../../Actions/nidAction";
import { toast } from "react-toastify";
import NIDField from "../NIDField";
// import DocsUpload from './DocsUpload';
// import InstaIDMain from './InstaIDMain';
import NationalIDForm from "./NationalIDForm";
import Loader from "./../Common/loader";
import tick from "../../assets/img/check_circle.png";
import NationalIdFormWithOCR from './NationalIDWithOCR'

const NationalIDTab = (props) => {

  const paramData  = useParams();
  const {
    tabs,
    nidDetailsNew,
    defaultFieldName,
    isOCRFlag,
    //  handleInputChange,
    //  uploadFile,
    //  disabledOptionsArray = [],
    //  handleFileDelete,
    //  showConfirmedAadhaar,
    //  confirmedAadhaar,
    //  confirmedAadhaarError,
    //  handleReEnter,
    //  errorData
  } = props;

  const navigate = useNavigate();
  const [isOCR, setIsOCR] = useState('');

  useEffect(() => {
    return () => {
      // localStorage.removeItem('activeNIDTab');
      localStorage.removeItem('NIDSaved');
    }
  },[])

 
  useEffect(() => {
    let allFields = Object.keys(tabs);
    let field = "";
    let key;

    let tabName = localStorage.getItem("activeNIDTab");
    let savedTabName = localStorage.getItem("NIDSaved");
    if (tabName && localStorage.getItem("NIDSaved") == 'true'){
      let name = getNextTabName();
      if(name){
      localStorage.setItem('NIDSaved', false);
       if(name.includes('NID')){
         key = parseInt(name.split('-')[1]) - 1;
         field = 'NID_Default_Field';
        }else{
          field = name;
        }
      }else{
        // redirect
        handleRedirect();
      }  
    }else if(tabName){
      if (tabName.includes("NID")) {
        key = parseInt(tabName.split("-")[1]) - 1;
        field = "NID_Default_Field";
      } else {
        field = tabName;
      } 
    }else{
      field = allFields[0];
      if(field.includes("NID")){
        // key = field.split("-")[1];
        localStorage.setItem('activeNIDTab', `NID-1`);
      }else{
        localStorage.setItem('activeNIDTab', field);
      }
    }
    setSelectedField(field);
    setAllFields(allFields);

    // getFieldName(field);
    // changeTab(field);
    if (field == "NID_Default_Field") {
      if (key) {
        setNidFieldData(nidDetailsNew.fields[field][key]);
        getFieldName(field, key+1);
        if (nidDetailsNew?.["check_status"]?.[field]?.[key]) setSaveData(true);
      } else {
        setNidFieldData(nidDetailsNew.fields[field][0]);
        getFieldName(field, 1);
        if (nidDetailsNew?.["check_status"]?.[field]?.[0]) setSaveData(true);
      }
    } else {
      setNidFieldData(nidDetailsNew?.fields[field]);
      getFieldName(field);
      if (nidDetailsNew?.["check_status"]?.[field]) setSaveData(true);
    }
    // setNidFieldData(tabs[defaultFieldName]);
  }, [tabs,nidDetailsNew]);



  // useEffect(() => {
  //   let allFields = Object.keys(tabs)
  //   let field = allFields[0];

  // setSelectedField(field);
  // setAllFields(allFields);

  // setNidFieldData(tabs[defaultFieldName]);
  // },[defaultFieldName])

  const [selectedField, setSelectedField] = useState(defaultFieldName);
  const [selectedFieldName, setSelectedFieldName] = useState(defaultFieldName);
  const [nidFieldData, setNidFieldData] = useState(defaultFieldName);
  const [ibridgeField,setIbridgeField]=useState({});
  const [allFields, setAllFields] = useState([]);
  // const [errorData, setErrorData] = useState({});
  const [nidDetails, setNIDDetails] = useState({});
  const [unsavedNIDDetails, setUnsavedNIDDetails] = useState({});
  const [deletedFileName, setDeletedFileName] = useState(null);
  const [addedFileName, setAddedFileName] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorData, setErrorData] = useState({});
  const [disabledOptionsArray, setDisabledOptionsArray] = useState([]);
  const [confirmedAadhaar, setConfirmedAadhaar] = useState("");
  const [confirmedAadhaarError, setConfirmedAadhaarError] = useState(false);
  const [showConfirmedAadhaar, setShowConfirmedAadhaar] = useState(false);
  const [role, setRole] = useState();
  const [NIDKey, setNIDKey] = useState("");
  const [saveData, setSaveData] = useState(false);

  const storeData = useSelector((state) => state.nidDetails);
  const storeData2 = useSelector((state) => state.uploadFilesData);
  const storeData3 = useSelector((state) => state.saveNidDetailsData);
  const storeData4 = useSelector((state) => state.deletedFilesData);
  const storeSavePan = useSelector((state) => state.savePan);

  const dispatch = useDispatch();
  const storeDataUser = useSelector((state) => state.user);
  const { userData } = storeDataUser;
  const { nidDetailsData, loading: getNIDLoading } = storeData;
  const { nidUploadFilesData, loading: uploadFileLoading } = storeData2;
  const { saveNIDDetailsData, loading: saveNIDDetailsDataLoading } = storeData3;
  const { deleteUploadedFileData, loading: deleteUploadedFileDataLoading } =
    storeData4;
  const { savePanReducerData, loading: savePanLoading } = storeSavePan;
  

  let allTabs;

  useEffect(() => {
    if (
      typeof nidDetailsData.data !== "undefined" &&
      nidDetailsData.data !== null
    ) {
      if (Object.keys(unsavedNIDDetails).length === 0) {
        setNIDDetails(nidDetailsData.data);
        // createErrorData(nidDetailsData.data);
        // createDisabledOptions(nidDetailsData.data);
        if (nidDetails?.fields) allTabs = Object.keys(nidDetails?.fields);
      } else {
        if (deletedFileName) {
          // handleDeletedFile();
        }
        if (addedFileName) {
          // handleAddedFile(nidDetailsData.data);
        }
      }
    }
  }, [nidDetailsData, storeData,nidDetailsNew]);

  //on successful save nid whether to go on next tab or the next check
  useEffect(() => {
    if (
      saveNIDDetailsData?.data &&
      Object.keys(saveNIDDetailsData?.data).length > 0
    ) {
      if (saveNIDDetailsData?.data?.group?.is_nid_pending) {
        if(isOCRFlag){
          dispatch(getNIDDetailsWithOCR())
           }
           else{
            dispatch(getNIDDetails());
           }
        //dispatch(getNIDDetails());
        // localStorage.removeItem("activeNIDTab");
        localStorage.setItem("NIDSaved", true);
      } else {
        // redirect
        // handleRedirect(saveNIDDetailsData);
      }
    }

  },[saveNIDDetailsData])

    //on successful save nid whether to go on next tab or the next check
    useEffect(() => {
      if (
        savePanReducerData?.data &&
        Object.keys(savePanReducerData?.data).length > 0
      ) {
        if (savePanReducerData?.data?.group?.is_nid_pending) {
          if(isOCRFlag){
            dispatch(getNIDDetailsWithOCR())
             }
             else{
              dispatch(getNIDDetails());
             }
          //dispatch(getNIDDetails());
          // localStorage.removeItem("activeNIDTab");
          localStorage.setItem("NIDSaved", true);
        } else {
          // redirect
          // handleRedirect(savePanReducerData);
        }
      }
  
    },[savePanReducerData])

  useEffect(() => {
    if(userData){
      if(userData?.data?.is_instant_verification_required == 1 && isOCRFlag || userData?.is_instant_verification_required == 1 && isOCRFlag){
        setIsOCR(true);
      }
    }else{
      setIsOCR(false);
    }
  },[userData])
  

  useEffect(() => {
    if(Object.keys(nidDetailsNew?.fields).length > 0){
      let obj = nidDetailsNew?.NID_Dropdown;
      let data = _.cloneDeep(nidDetailsNew?.fields);

      for(let key in data['NID_Default_Field']){
        let field = data['NID_Default_Field'][key];
        if(data['NID_Default_Field'][key][0].field_name == 'nid_selected[]' && data['NID_Default_Field'][key][0].value != ''){
          let val = data['NID_Default_Field'][key][0].value;
          let id = parseInt(setId(val));
          delete(obj[id]);
        }
      }
      setDisabledOptionsArray(obj);
    }
  },[nidDetailsNew])

  const getNextTabName = () => {
    let arr = [];
    const obj=nidDetailsNew?.check_status||{}
    Object.entries(obj).map(([item, key]) => {
      console.log(item, "cnksjn", key);
      if (item == "NID_Default_Field") {
        key.map((data, idx) => {
          let tabName = `NID-${idx + 1}`;
          arr.push({ [tabName]: data });
        });
      } else {
        arr.push({ [item]: key });
      }
    });
    console.log(arr);
    let fieldName = "";
    arr.map((obj,idx) => {
      // for(let i = 0; i < arr.length; i++){
      let key = Object.keys(obj)[0];
      // let value = Object.values(obj)[0];
      // let key = arr[i];
      // if (value == 0 && fieldName == "") {
      //   fieldName = key;
      //   localStorage.setItem("activeNIDTab", key);
      //   return null;
      // }
      let currentTab = localStorage.getItem('activeNIDTab');
      if(currentTab == key && idx < arr.length - 1){
        let ob = arr[idx+1];
        let val = Object.keys(ob)[0];
        // changeTab(val);
        fieldName = val;
        // return fieldName;
      }
    });
    console.log(fieldName);
    if(fieldName == ''){
      return false;
    }else{
      localStorage.setItem('activeNIDTab', fieldName);
    }
    return fieldName;
  }

  const handleRedirect = () => {
    const hasReferenceNumber =
      saveNIDDetailsData && saveNIDDetailsData.data ? true : false;
      const hasReferenceNumber1 =
      savePanReducerData && savePanReducerData.data ? true : false;
    if (hasReferenceNumber) {
      const referenceNumber = saveNIDDetailsData.data.reference_number;
      const groupID = saveNIDDetailsData.data.group.group_id;
      if (groupID && groupID === "profile_preview") {
        navigate(`/case-initiation/profile-preview/${referenceNumber}`);
      } else {
        navigate(`/case-initiation/check-detail/${referenceNumber}/${groupID}`);
      }
      dispatch(deleteSaveNIDDetails());
      localStorage.removeItem('activeNIDTab');
      localStorage.removeItem('NIDSaved');
    }

    if (hasReferenceNumber1) {
      const referenceNumber = savePanReducerData.data.reference_number;
      const groupID = savePanReducerData.data.group.group_id;
      if (groupID && groupID === "profile_preview") {
        navigate(`/case-initiation/profile-preview/${referenceNumber}`);
      } else {
        navigate(`/case-initiation/check-detail/${referenceNumber}/${groupID}`);
      }
      dispatch(deleteSavePanDetails());
      localStorage.removeItem('activeNIDTab');
      localStorage.removeItem('NIDSaved');
    }
  }

  const setId = (field, key) => {
    if (field == "Voter_Fields" || field == "VOTER ID") {
      return '142';
    } else if (field == "Passport_Fields" || field == "PASSPORT") {
      return '44';
    } else if (field == "PAN_fields" || field == "PAN CARD") {
      return '45';
    } else if (field == "Aadhaar_Fields" || field == "AADHAAR") {
      return '235';
    } else if (field == "Driving_Fields" || field == "DRIVING LICENSE") {
      return '101';
    } else return '999999';
  };

  const changeTab = (field, key) => {
    setIsLoading(true);
    setSelectedField(field);
    localStorage.setItem("NIDSaved", false);
    // const nidFieldData = nidDetails.fields[field];
    if (field == "NID_Default_Field") {
      setNidFieldData(nidDetails.fields[field][key-1]);
      // localStorage.setItem("activeNIDTab", `${field}-${key}`);
      localStorage.setItem("activeNIDTab", `NID-${key}`);
      if (nidDetailsNew?.["check_status"]?.[field]?.[key-1]) setSaveData(true);
    } else {
      setNidFieldData(nidDetails.fields[field]);
      localStorage.setItem("activeNIDTab", field);
      if (nidDetailsNew?.["check_status"]?.[field]) setSaveData(true);
    }
    getFieldName(field, key);
    setIsLoading(false);
  };

  const handleContinueRedirection = (data) => {
    let allFields = Object.keys(tabs);
    let field = "";
    let key;

    // let tabName = localStorage.getItem("activeNIDTab");
    // let savedTabName = localStorage.getItem("NIDSaved");
    // if (tabName && localStorage.getItem("NIDSaved") == 'true'){
      const isNidPending=data?.group?.is_nid_pending;
      if(isNidPending){
        let name = getNextTabName();
        if(name){
        localStorage.setItem('NIDSaved', false);
            field = name;
        }
         
      }else{
        handleRedirectContinue(data);
      }
    
    // }
      setSelectedField(field);
      setAllFields(allFields);

      setNidFieldData(nidDetailsNew?.fields[field]);
      getFieldName(field);
      if (nidDetailsNew?.["check_status"]?.[field]) setSaveData(true);
    
  }


  const handleRedirectContinue = (data) => {
    const referenceNumber=paramData?.caseId;
    if (referenceNumber) {
      const groupID = data?.group?.group_id;
      if (groupID && groupID === "profile_preview") {
        navigate(`/case-initiation/profile-preview/${referenceNumber}`);
      } else {
        navigate(`/case-initiation/check-detail/${referenceNumber}/${groupID}`);
      }
      dispatch(deleteSaveNIDDetails());
      localStorage.removeItem('activeNIDTab');
      localStorage.removeItem('NIDSaved');
    }
  }


  const getFieldName = (field, key) => {
    if (field == "Voter_Fields") {
      setSelectedFieldName("Voter ID");
    } else if (field == "Passport_Fields") {
      setSelectedFieldName("Passport");
    } else if (field == "PAN_fields") {
      setSelectedFieldName("Pan Card");
    } else if (field == "Aadhaar_Fields") {
      setSelectedFieldName("Aadhar Card");
    } else if (field == "Driving_Fields") {
      setSelectedFieldName("Driving License");
    } else if (field == "NID_Default_Field" && key != undefined) {
      setSelectedFieldName(`NID-${key}`);
      setNIDKey(key-1);
    } else setSelectedFieldName("NID-1");
  };

  const getTabName = (field, key) => {
    if (field == "Voter_Fields") {
      return "Voter ID";
    } else if (field == "Passport_Fields") {
      return "Passport";
    } else if (field == "PAN_fields") {
      return "Pan Card";
    } else if (field == "Aadhaar_Fields") {
      return "Aadhar Card";
    } else if (field == "Driving_Fields") {
      return "Driving License";
    } else if (field == "NID_Default_Field" && key != undefined) {
      return `NID-${key + 1}`;
    } else return "NID-1";
  };
    const createDisabledOptions = (data) => {
      if (data.fields.NID_Default_Field) {
        let arr = [];
        for (let i = 0; i < data.fields.NID_Default_Field.length; i++) {
          arr.push(data.fields.NID_Default_Field[i][0].value);
        }
        setDisabledOptionsArray(arr);
      }
    };
    const handlePreviewData = (data) => {
      for (let i in data) {
        if (i.includes("NID_Default_Field")) {
          const [field, index, fieldName] = i.split("-");
          let updatedNIDDetails = _.cloneDeep(nidDetails);
          for (let j in updatedNIDDetails.fields[field][index]) {
            if (
              updatedNIDDetails.fields[field][index][j].field_name === fieldName
            ) {
              updatedNIDDetails.fields[field][index][j].value = data[i].preview;
              updatedNIDDetails.fields[field][index][j].id = data[i].docId;
              setErrorData((prevState) => ({
                ...prevState,
                [i]: false,
              }));
              setNIDDetails(updatedNIDDetails);
            }
          }
        } else {
          const [field, fieldName] = i.split("-");
          let updatedNIDDetails = _.cloneDeep(nidDetails);
          for (let j in updatedNIDDetails.fields[field]) {
            if (updatedNIDDetails.fields[field][j].field_name == fieldName) {
              updatedNIDDetails.fields[field][j].value = data[i].preview;
              updatedNIDDetails.fields[field][j].id = data[i].docId;
              setErrorData((prevState) => ({
                ...prevState,
                [i]: false,
              }));
              setNIDDetails(updatedNIDDetails);
            }
          }
        }
      }
    };
    const createErrorData = (data) => {
      const errorObj = {};
      for (var i in data.fields) {
        if (i === "NID_Default_Field") {
          for (var j in data.fields[i]) {
            for (var k in data.fields[i][j]) {
              if (data.fields[i][j][k].is_mandatory === 1) {
                errorObj[`${i}-${j}-${data.fields[i][j][k].field_name}`] = false;
              }
            }
          }
        } else {
          for (var j in data.fields[i]) {
            if (data.fields[i][j].is_mandatory === 1) {
              errorObj[`${i}-${data.fields[i][j].field_name}`] = false;
            }
          }
        }
      }
      setErrorData(errorObj);
    };
  
    const saveNidDetails = (e) => {
      e.preventDefault();
      setIsLoading(true);
      let hasError = false;
      let errors = _.cloneDeep(errorData);
      for (let i in nidDetails.fields) {
        if (i === "NID_Default_Field") {
          for (let j in nidDetails.fields[i]) {
            for (let k in nidDetails.fields[i][j]) {
              if (
                nidDetails.fields[i][j][k].is_mandatory === 1 &&
                (nidDetails.fields[i][j][k].value === "" ||
                  nidDetails.fields[i][j][k].value === null)
              ) {
                if (
                  nidDetails.fields[i][j][k].field_name.includes("back") ||
                  nidDetails.fields[i][j][k].field_name.includes("front")
                ) {
                  let isRequired = true;
                  const nidSelected = nidDetails.fields[i][j][0].value;
                  const docSide = nidDetails.fields[i][j][k].field_name.includes(
                    "back"
                  )
                    ? "back"
                    : "front";
                  if (nidSelected == "PAN CARD" && docSide == "back") {
                    isRequired = false;
                  }
                  if (
                    nidSelected == "AADHAAR" &&
                    (docSide == "back" || docSide == "front")
                  ) {
                    isRequired = false;
                  }
                  hasError = isRequired == true ? true : false;
                  errors[`${i}-${j}-${nidDetails.fields[i][j][k].field_name}`] =
                    isRequired == true ? true : false;
                } else {
                  hasError = true;
                  errors[
                    `${i}-${j}-${nidDetails.fields[i][j][k].field_name}`
                  ] = true;
                }
              }
            }
          }
        } else {
          for (let j in nidDetails.fields[i]) {
            const isMandatory = nidDetails.fields[i][j].is_mandatory;
            const fieldValue = nidDetails.fields[i][j].value;
            if (isMandatory == 1 && (fieldValue == "" || fieldValue == null)) {
              hasError = true;
              errors[`${i}-${nidDetails.fields[i][j].field_name}`] = true;
            }
          }
        }
      }
      for (var i in errors) {
        if (errors[i] == true) {
          hasError = true;
          break;
        }
      }
      if (showConfirmedAadhaar) {
        if (confirmedAadhaarError == true) {
          hasError = true;
        } else if (confirmedAadhaar == "") {
          hasError = true;
          setConfirmedAadhaarError(true);
        }
      }
      setErrorData(errors);
      if (hasError) {
        setIsLoading(false);
        window.scrollTo(0, 0);
        return;
      }
      // sendNidDetails();
    };
  
    const sendNidDetails = async () => {
      let selectedDocs = [];
      let nid_selected = [];
      let ele_doc_name = [];
      let ele_doc_numb = [];
      let ele_check_id = [];
  
      for (let i in nidDetails.fields) {
        if (i == "NID_Default_Field") {
          for (let j in nidDetails.fields[i]) {
            for (let k in nidDetails.fields[i][j]) {
              if (nidDetails.fields[i][j][k].field_name == "nid_selected[]") {
                selectedDocs.push(nidDetails.fields[i][j][k].value);
              }
              if (nidDetails.fields[i][j][k].field_name == "ele_doc_name[]") {
                ele_doc_name.push(nidDetails.fields[i][j][k].value);
              }
              if (nidDetails.fields[i][j][k].field_name == "ele_doc_numb[]") {
                ele_doc_numb.push(nidDetails.fields[i][j][k].value);
              }
              if (nidDetails.fields[i][j][k].field_name == "ele_check_id[]") {
                ele_check_id.push(nidDetails.fields[i][j][k].value);
              }
            }
          }
        } else {
          for (let j in nidDetails.fields[i]) {
            if (nidDetails.fields[i][j].field_name == "nid_selected[]") {
              selectedDocs.push(nidDetails.fields[i][j].value);
            }
            if (nidDetails.fields[i][j].field_name == "ele_doc_name[]") {
              ele_doc_name.push(nidDetails.fields[i][j].value);
            }
            if (nidDetails.fields[i][j].field_name == "ele_doc_numb[]") {
              ele_doc_numb.push(nidDetails.fields[i][j].value);
            }
            if (nidDetails.fields[i][j].field_name == "ele_check_id[]") {
              ele_check_id.push(nidDetails.fields[i][j].value);
            }
          }
        }
      }
  
      for (let i in selectedDocs) {
        for (let j in nidDetails.Default_Nid_Dropdown) {
          if (selectedDocs[i] == nidDetails.Default_Nid_Dropdown[j]) {
            nid_selected.push(j);
          }
        }
      }
  
      await dispatch(
        saveNIDDetails(nid_selected, ele_doc_name, ele_doc_numb, ele_check_id)
      );
    };
  
    const handleError = (name, val, fieldKey, index, nidFieldIndex) => {
      const fieldArr =
        fieldKey === "NID_Default_Field"
          ? nidDetails.fields[fieldKey][nidFieldIndex]
          : nidDetails.fields[fieldKey];
      const errorKey =
        fieldKey === "NID_Default_Field"
          ? `${fieldKey}-${nidFieldIndex}-${name}`
          : `${fieldKey}-${name}`;
      let selectedDoc = null;
      for (var i in fieldArr) {
        if (fieldArr[i].field_name == "nid_selected[]") {
          selectedDoc = fieldArr[i].value;
          break;
        }
      }
  
      if (fieldKey === "NID_Default_Field") {
        if (name === "nid_selected[]") {
          setErrorData((prevState) => ({
            ...prevState,
            [errorKey]: val && val !== "" ? false : true,
          }));
        }
      } else {
        if (name === "nid_selected[]") {
          setErrorData((prevState) => ({
            ...prevState,
            [`${fieldKey}-${name}`]: val && val !== "" ? false : true,
          }));
        }
      }
  
      if (name.includes("name")) {
        setErrorData((prevState) => ({
          ...prevState,
          [errorKey]: !validateAlphabetsAndSpace(val),
        }));
      } else if (name.includes("numb")) {
        if (selectedDoc === "PAN CARD") {
          setErrorData((prevState) => ({
            ...prevState,
            [errorKey]: !validatePAN(val),
          }));
        }
        if (selectedDoc === "AADHAAR") {
          //for showing field to re-enter aadhaar
          if (fieldKey == "NID_Default_Field") {
            const hasError = !validateAadhaar(val);
            if (!hasError) {
              setShowConfirmedAadhaar(true);
              setConfirmedAadhaar("");
            } else {
              setShowConfirmedAadhaar(false);
              setConfirmedAadhaar("");
            }
          }
          setErrorData((prevState) => ({
            ...prevState,
            [errorKey]: !validateAadhaar(val),
          }));
        }
        if (selectedDoc === "PASSPORT") {
          setErrorData((prevState) => ({
            ...prevState,
            [errorKey]: !validatePassport(val),
          }));
        }
        if (selectedDoc === "VOTER ID") {
          setErrorData((prevState) => ({
            ...prevState,
            [errorKey]: val !== "" ? false : true,
          }));
        }
        if (selectedDoc === "") {
          setErrorData((prevState) => ({
            ...prevState,
            [errorKey]: val !== "" ? false : true,
          }));
        }
      }
    };
  
    const handleInputChange = (name, val, fieldKey, index, nidFieldIndex,inputField,ibridgeFieldId) => {
      console.log("OCR fields...", name, val) //doc_id
      // handleError(name, val, fieldKey, index, nidFieldIndex);
      // if (fieldKey == "NID_Default_Field" && name === "nid_selected[]") {
      //   let arr = _.cloneDeep(disabledOptionsArray);
      //   arr[nidFieldIndex] = val;
      //   setDisabledOptionsArray(arr);
      //   const currentVal =
      //     nidDetails.fields["NID_Default_Field"][nidFieldIndex][index].value;
      //   if ((currentVal !== "" || currentVal != null) && val !== currentVal) {
      //     removeAllDetails(val, index, nidFieldIndex);
      //     return;
      //   }
      // }
  
      // if (fieldKey !== "NID_Default_Field") {
      //   setNIDDetails((prevState) => ({
      //     ...prevState,
      //     fields: {
      //       ...prevState.fields,
      //       [fieldKey]: {
      //         ...prevState.fields[fieldKey],
      //         [index]: {
      //           ...prevState.fields[fieldKey][index],
      //           value: val,
      //         },
      //       },
      //     },
      //   }));
      // } else {
      //   let updatedNidDetails = _.cloneDeep(nidDetails);
      //   updatedNidDetails.fields[fieldKey][nidFieldIndex][index].value = val;
      //   setNIDDetails(updatedNidDetails);
      // }

      // setNidFieldData((prevstate)=>({
      //   ...prevstate,
      //   [index]:{...prevstate[index],value:val}
      // }))
        if(name && !ibridgeFieldId){
      let data = _.cloneDeep(nidFieldData);
      for(var key in data){
        console.log(data[key]);
        if(data[key].field_name == name){
          data[key].value = val
          // let name = data[key].field_name;
          // setErrorData((prev) => ({
          //   ...prev,
          //   [name] : ''
          // }))
        }
      }
      setNidFieldData(data);
    }

    else{
  
      if(ibridgeFieldId != ""){
        
        let data = _.cloneDeep(nidFieldData);
        for(var key in data){
          console.log(data[key]);
          if(data[key].ibridge_field_id == ibridgeFieldId){
            data[key].value = val
            //let name = data[key].field_name;
            let obj={};
            obj[ibridgeFieldId]=val;
            setIbridgeField((prev) => ({
              ...prev,
            [ibridgeFieldId]: val
            }))
          }
        }
          setNidFieldData(data);

      }
    }
    };

    const saveDateInput=(name, val, fieldKey, index, nidFieldIndex,inputField,ibridgeFieldId)=>{
      if(name){
        let data = _.cloneDeep(nidFieldData);
        for(var key in data){
          console.log(data[key]);
          if(data[key].field_name == name){
            data[key].value = val
            // let name = data[key].field_name;
            // setErrorData((prev) => ({
            //   ...prev,
            //   [name] : ''
            // }))
          }
        }
        setNidFieldData(data);
      }
      else{
        if(ibridgeFieldId != ""){
          
          let data = _.cloneDeep(nidFieldData);
          for(var key in data){
            console.log(data[key]);
            if(data[key].ibridge_field_id == ibridgeFieldId){
              data[key].value = val
              //let name = data[key].field_name;
              let obj={};
              obj[ibridgeFieldId]=val;
              setIbridgeField((prev) => ({
                ...prev,
              [ibridgeFieldId]: val
              }))
            }
          }
            setNidFieldData(data);
  
        }
      }
    }

    console.log(ibridgeField);
  
    const removeAllDetails = (val, index, nidFieldIndex) => {
      const nidDetailsClone = _.cloneDeep(nidDetails);
      for (var i in nidDetailsClone.fields["NID_Default_Field"][nidFieldIndex]) {
        const fieldName =
          nidDetailsClone.fields["NID_Default_Field"][nidFieldIndex][i]
            .field_name;
        if (fieldName !== "ele_check_id[]") {
          if (fieldName === "nid_selected[]") {
            nidDetailsClone.fields["NID_Default_Field"][nidFieldIndex][i].value =
              val;
          } else {
            nidDetailsClone.fields["NID_Default_Field"][nidFieldIndex][i].value =
              "";
          }
        }
      }
      setNIDDetails(nidDetailsClone);
    };
    const uploadFile = async (
      docCheckID,
      docSubCheckID,
      docSide,
      fieldKey,
      checkIDData,
      selectedFile,
      fieldName,
      fieldNIDIndex,
      errorField,
      activeIndex
    ) => {
      if (docSubCheckID) {
        setAddedFileName(errorField);
      //  setUnsavedNIDDetails(_.cloneDeep(nidDetails));
        // setIsLoading(true);
        let OCRFlag = isOCRFlag;
        await dispatch(
          uploadFileViaMultipartNID(
            docCheckID,
            docSubCheckID,
            docSide,
            fieldKey,
            checkIDData,
            selectedFile,
            fieldName,
            fieldNIDIndex,
            activeIndex,
            OCRFlag,
          )
        );
        // await dispatch(getNIDDetails());
        //  await dispatch(getNIDDetailsWithOCR())
        
      } else {
        setAddedFileName(null);
        const msg = "Please select the document type first.";
        toast.error(msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };

  
    const handleFileDelete = async (recordArr, errorField,activeIndex,nidCheckid) => {
      // setIsLoading(true);
       setDeletedFileName(errorField);
       let OCRFlag = isOCRFlag;
      await dispatch(removeUploadedFile("nid_file", recordArr,null,()=>{},activeIndex,OCRFlag,nidCheckid));
      // await dispatch(getNIDDetails());
      //  await dispatch(getNIDDetailsWithOCR())
    };

    const callbackRefresh = () => {
      dispatch(getNIDDetailsWithOCR());

    }
  
    const handleReEnter = (val) => {
      setConfirmedAadhaar(val);
      const nidFields = nidDetails.fields["NID_Default_Field"];
      let aadhaarNumber = null;
      for (var i in nidFields) {
        for (var j in nidFields[i]) {
          if (
            nidFields[i][j].field_name === "ele_doc_numb[]" &&
            nidFields[i][0].value === "AADHAAR"
          ) {
            aadhaarNumber = nidFields[i][j].value;
          }
        }
      }
      if (aadhaarNumber) {
        if (val == aadhaarNumber) {
          setConfirmedAadhaarError(false);
        } else {
          setConfirmedAadhaarError(true);
        }
      }
    };
  
    const handleSubmitForPreview = (e) => {
      e.preventDefault();
      const currentUrl = window.location.href;
      const [partA, partB] = currentUrl.split("/check-detail/");
      const [reference, route] = partB.split("/");
      navigate(`/case-initiation/profile-preview/${reference}`);
    };

    const getIsMandatoryFlag = (fieldName) => {
      const checkObj = nidDetailsNew?.fields?.[fieldName];
      const checkID = checkObj?.[1]?.value;
      let flag = false;
      const obj=nidDetailsNew?.['info']||{};
      Object.values(obj).map((item) => {
        if(item.check_id == checkID && item.is_mandatory == 1){
          flag = true;
        }
      })
      return flag;
    }

  // const setPrefilledData = (fieldsData, fieldName, key) => {
  //  let savedObj = {}
  //   if(fieldName == 'NID_Default_Field'){
  //     if(key){

  //     }else{

  //     }
  //   }else{

  //   }
  // }

  // const createDisabledOptions = (data) => {
  //   if (data.fields.NID_Default_Field) {
  //     let arr = [];
  //     for (let i = 0; i < data.fields.NID_Default_Field.length; i++) {
  //       arr.push(data.fields.NID_Default_Field[i][0].value);
  //     }
  //     setDisabledOptionsArray(arr);
  //   }
  // };
  // const handlePreviewData = (data) => {
  //   for (let i in data) {
  //     if (i.includes("NID_Default_Field")) {
  //       const [field, index, fieldName] = i.split("-");
  //       let updatedNIDDetails = _.cloneDeep(nidDetails);
  //       for (let j in updatedNIDDetails.fields[field][index]) {
  //         if (
  //           updatedNIDDetails.fields[field][index][j].field_name === fieldName
  //         ) {
  //           updatedNIDDetails.fields[field][index][j].value = data[i].preview;
  //           updatedNIDDetails.fields[field][index][j].id = data[i].docId;
  //           setErrorData((prevState) => ({
  //             ...prevState,
  //             [i]: false,
  //           }));
  //           setNIDDetails(updatedNIDDetails);
  //         }
  //       }
  //     } else {
  //       const [field, fieldName] = i.split("-");
  //       let updatedNIDDetails = _.cloneDeep(nidDetails);
  //       for (let j in updatedNIDDetails.fields[field]) {
  //         if (updatedNIDDetails.fields[field][j].field_name == fieldName) {
  //           updatedNIDDetails.fields[field][j].value = data[i].preview;
  //           updatedNIDDetails.fields[field][j].id = data[i].docId;
  //           setErrorData((prevState) => ({
  //             ...prevState,
  //             [i]: false,
  //           }));
  //           setNIDDetails(updatedNIDDetails);
  //         }
  //       }
  //     }
  //   }
  // };
  // const createErrorData = (data) => {
  //   const errorObj = {};
  //   for (var i in data.fields) {
  //     if (i === "NID_Default_Field") {
  //       for (var j in data.fields[i]) {
  //         for (var k in data.fields[i][j]) {
  //           if (data.fields[i][j][k].is_mandatory === 1) {
  //             errorObj[`${i}-${j}-${data.fields[i][j][k].field_name}`] = false;
  //           }
  //         }
  //       }
  //     } else {
  //       for (var j in data.fields[i]) {
  //         if (data.fields[i][j].is_mandatory === 1) {
  //           errorObj[`${i}-${data.fields[i][j].field_name}`] = false;
  //         }
  //       }
  //     }
  //   }
  //   setErrorData(errorObj);
  // };

  // const saveNidDetails = (e) => {
  //   e.preventDefault();
  //   setIsLoading(true);
  //   let hasError = false;
  //   let errors = _.cloneDeep(errorData);
  //   for (let i in nidDetails.fields) {
  //     if (i === "NID_Default_Field") {
  //       for (let j in nidDetails.fields[i]) {
  //         for (let k in nidDetails.fields[i][j]) {
  //           if (
  //             nidDetails.fields[i][j][k].is_mandatory === 1 &&
  //             (nidDetails.fields[i][j][k].value === "" ||
  //               nidDetails.fields[i][j][k].value === null)
  //           ) {
  //             if (
  //               nidDetails.fields[i][j][k].field_name.includes("back") ||
  //               nidDetails.fields[i][j][k].field_name.includes("front")
  //             ) {
  //               let isRequired = true;
  //               const nidSelected = nidDetails.fields[i][j][0].value;
  //               const docSide = nidDetails.fields[i][j][k].field_name.includes(
  //                 "back"
  //               )
  //                 ? "back"
  //                 : "front";
  //               if (nidSelected == "PAN CARD" && docSide == "back") {
  //                 isRequired = false;
  //               }
  //               if (
  //                 nidSelected == "AADHAAR" &&
  //                 (docSide == "back" || docSide == "front")
  //               ) {
  //                 isRequired = false;
  //               }
  //               hasError = isRequired == true ? true : false;
  //               errors[`${i}-${j}-${nidDetails.fields[i][j][k].field_name}`] =
  //                 isRequired == true ? true : false;
  //             } else {
  //               hasError = true;
  //               errors[
  //                 `${i}-${j}-${nidDetails.fields[i][j][k].field_name}`
  //               ] = true;
  //             }
  //           }
  //         }
  //       }
  //     } else {
  //       for (let j in nidDetails.fields[i]) {
  //         const isMandatory = nidDetails.fields[i][j].is_mandatory;
  //         const fieldValue = nidDetails.fields[i][j].value;
  //         if (isMandatory == 1 && (fieldValue == "" || fieldValue == null)) {
  //           hasError = true;
  //           errors[`${i}-${nidDetails.fields[i][j].field_name}`] = true;
  //         }
  //       }
  //     }
  //   }
  //   for (var i in errors) {
  //     if (errors[i] == true) {
  //       hasError = true;
  //       break;
  //     }
  //   }
  //   if (showConfirmedAadhaar) {
  //     if (confirmedAadhaarError == true) {
  //       hasError = true;
  //     } else if (confirmedAadhaar == "") {
  //       hasError = true;
  //       setConfirmedAadhaarError(true);
  //     }
  //   }
  //   setErrorData(errors);
  //   if (hasError) {
  //     setIsLoading(false);
  //     window.scrollTo(0, 0);
  //     return;
  //   }
  //   // sendNidDetails();
  // };

  // const sendNidDetails = async () => {
  //   let selectedDocs = [];
  //   let nid_selected = [];
  //   let ele_doc_name = [];
  //   let ele_doc_numb = [];
  //   let ele_check_id = [];

  //   for (let i in nidDetails.fields) {
  //     if (i == "NID_Default_Field") {
  //       for (let j in nidDetails.fields[i]) {
  //         for (let k in nidDetails.fields[i][j]) {
  //           if (nidDetails.fields[i][j][k].field_name == "nid_selected[]") {
  //             selectedDocs.push(nidDetails.fields[i][j][k].value);
  //           }
  //           if (nidDetails.fields[i][j][k].field_name == "ele_doc_name[]") {
  //             ele_doc_name.push(nidDetails.fields[i][j][k].value);
  //           }
  //           if (nidDetails.fields[i][j][k].field_name == "ele_doc_numb[]") {
  //             ele_doc_numb.push(nidDetails.fields[i][j][k].value);
  //           }
  //           if (nidDetails.fields[i][j][k].field_name == "ele_check_id[]") {
  //             ele_check_id.push(nidDetails.fields[i][j][k].value);
  //           }
  //         }
  //       }
  //     } else {
  //       for (let j in nidDetails.fields[i]) {
  //         if (nidDetails.fields[i][j].field_name == "nid_selected[]") {
  //           selectedDocs.push(nidDetails.fields[i][j].value);
  //         }
  //         if (nidDetails.fields[i][j].field_name == "ele_doc_name[]") {
  //           ele_doc_name.push(nidDetails.fields[i][j].value);
  //         }
  //         if (nidDetails.fields[i][j].field_name == "ele_doc_numb[]") {
  //           ele_doc_numb.push(nidDetails.fields[i][j].value);
  //         }
  //         if (nidDetails.fields[i][j].field_name == "ele_check_id[]") {
  //           ele_check_id.push(nidDetails.fields[i][j].value);
  //         }
  //       }
  //     }
  //   }

  //   for (let i in selectedDocs) {
  //     for (let j in nidDetails.Default_Nid_Dropdown) {
  //       if (selectedDocs[i] == nidDetails.Default_Nid_Dropdown[j]) {
  //         nid_selected.push(j);
  //       }
  //     }
  //   }

  //   await dispatch(
  //     saveNIDDetails(nid_selected, ele_doc_name, ele_doc_numb, ele_check_id)
  //   );
  // };

  // const handleError = (name, val, fieldKey, index, nidFieldIndex) => {
  //   const fieldArr =
  //     fieldKey === "NID_Default_Field"
  //       ? nidDetails.fields[fieldKey][nidFieldIndex]
  //       : nidDetails.fields[fieldKey];
  //   const errorKey =
  //     fieldKey === "NID_Default_Field"
  //       ? `${fieldKey}-${nidFieldIndex}-${name}`
  //       : `${fieldKey}-${name}`;
  //   let selectedDoc = null;
  //   for (var i in fieldArr) {
  //     if (fieldArr[i].field_name == "nid_selected[]") {
  //       selectedDoc = fieldArr[i].value;
  //       break;
  //     }
  //   }

  //   if (fieldKey === "NID_Default_Field") {
  //     if (name === "nid_selected[]") {
  //       setErrorData((prevState) => ({
  //         ...prevState,
  //         [errorKey]: val && val !== "" ? false : true,
  //       }));
  //     }
  //   } else {
  //     if (name === "nid_selected[]") {
  //       setErrorData((prevState) => ({
  //         ...prevState,
  //         [`${fieldKey}-${name}`]: val && val !== "" ? false : true,
  //       }));
  //     }
  //   }

  //   if (name.includes("name")) {
  //     setErrorData((prevState) => ({
  //       ...prevState,
  //       [errorKey]: !validateAlphabetsAndSpace(val),
  //     }));
  //   } else if (name.includes("numb")) {
  //     if (selectedDoc === "PAN CARD") {
  //       setErrorData((prevState) => ({
  //         ...prevState,
  //         [errorKey]: !validatePAN(val),
  //       }));
  //     }
  //     if (selectedDoc === "AADHAAR") {
  //       //for showing field to re-enter aadhaar
  //       if (fieldKey == "NID_Default_Field") {
  //         const hasError = !validateAadhaar(val);
  //         if (!hasError) {
  //           setShowConfirmedAadhaar(true);
  //           setConfirmedAadhaar("");
  //         } else {
  //           setShowConfirmedAadhaar(false);
  //           setConfirmedAadhaar("");
  //         }
  //       }
  //       setErrorData((prevState) => ({
  //         ...prevState,
  //         [errorKey]: !validateAadhaar(val),
  //       }));
  //     }
  //     if (selectedDoc === "PASSPORT") {
  //       setErrorData((prevState) => ({
  //         ...prevState,
  //         [errorKey]: !validatePassport(val),
  //       }));
  //     }
  //     if (selectedDoc === "VOTER ID") {
  //       setErrorData((prevState) => ({
  //         ...prevState,
  //         [errorKey]: val !== "" ? false : true,
  //       }));
  //     }
  //     if (selectedDoc === "") {
  //       setErrorData((prevState) => ({
  //         ...prevState,
  //         [errorKey]: val !== "" ? false : true,
  //       }));
  //     }
  //   }
  // };

  // const handleInputChange = (name, val, fieldKey, index, nidFieldIndex) => {
  //   handleError(name, val, fieldKey, index, nidFieldIndex);
  //   if (fieldKey == "NID_Default_Field" && name === "nid_selected[]") {
  //     let arr = _.cloneDeep(disabledOptionsArray);
  //     arr[nidFieldIndex] = val;
  //     setDisabledOptionsArray(arr);
  //     const currentVal =
  //       nidDetails.fields["NID_Default_Field"][nidFieldIndex][index].value;
  //     if ((currentVal !== "" || currentVal != null) && val !== currentVal) {
  //       removeAllDetails(val, index, nidFieldIndex);
  //       return;
  //     }
  //   }

  //   if (fieldKey !== "NID_Default_Field") {
  //     setNIDDetails((prevState) => ({
  //       ...prevState,
  //       fields: {
  //         ...prevState.fields,
  //         [fieldKey]: {
  //           ...prevState.fields[fieldKey],
  //           [index]: {
  //             ...prevState.fields[fieldKey][index],
  //             value: val,
  //           },
  //         },
  //       },
  //     }));
  //   } else {
  //     let updatedNidDetails = _.cloneDeep(nidDetails);
  //     updatedNidDetails.fields[fieldKey][nidFieldIndex][index].value = val;
  //     setNIDDetails(updatedNidDetails);
  //   }
  // };

  // const removeAllDetails = (val, index, nidFieldIndex) => {
  //   const nidDetailsClone = _.cloneDeep(nidDetails);
  //   for (var i in nidDetailsClone.fields["NID_Default_Field"][nidFieldIndex]) {
  //     const fieldName =
  //       nidDetailsClone.fields["NID_Default_Field"][nidFieldIndex][i]
  //         .field_name;
  //     if (fieldName !== "ele_check_id[]") {
  //       if (fieldName === "nid_selected[]") {
  //         nidDetailsClone.fields["NID_Default_Field"][nidFieldIndex][i].value =
  //           val;
  //       } else {
  //         nidDetailsClone.fields["NID_Default_Field"][nidFieldIndex][i].value =
  //           "";
  //       }
  //     }
  //   }
  //   setNIDDetails(nidDetailsClone);
  // };
  // const uploadFile = async (
  //   docCheckID,
  //   docSubCheckID,
  //   docSide,
  //   fieldKey,
  //   checkIDData,
  //   selectedFile,
  //   fieldName,
  //   fieldNIDIndex,
  //   errorField
  // ) => {
  //   if (docSubCheckID) {
  //     setAddedFileName(errorField);
  //     setUnsavedNIDDetails(_.cloneDeep(nidDetails));
  //     setIsLoading(true);
  //     await dispatch(
  //       uploadFileViaMultipartNID(
  //         docCheckID,
  //         docSubCheckID,
  //         docSide,
  //         fieldKey,
  //         checkIDData,
  //         selectedFile,
  //         fieldName,
  //         fieldNIDIndex
  //       )
  //     );
  //     await dispatch(getNIDDetails());
  //   } else {
  //     setAddedFileName(null);
  //     const msg = "Please select the document type first.";
  //     toast.error(msg, {
  //       position: "top-right",
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //     });
  //   }
  // };

  // const handleFileDelete = async (recordArr, errorField) => {
  //   setIsLoading(true);
  //   setDeletedFileName(errorField);
  //   await dispatch(removeUploadedFile("nid_file", recordArr));
  //   await dispatch(getNIDDetails());
  // };

  // const handleReEnter = (val) => {
  //   setConfirmedAadhaar(val);
  //   const nidFields = nidDetails.fields["NID_Default_Field"];
  //   let aadhaarNumber = null;
  //   for (var i in nidFields) {
  //     for (var j in nidFields[i]) {
  //       if (
  //         nidFields[i][j].field_name === "ele_doc_numb[]" &&
  //         nidFields[i][0].value === "AADHAAR"
  //       ) {
  //         aadhaarNumber = nidFields[i][j].value;
  //       }
  //     }
  //   }
  //   if (aadhaarNumber) {
  //     if (val == aadhaarNumber) {
  //       setConfirmedAadhaarError(false);
  //     } else {
  //       setConfirmedAadhaarError(true);
  //     }
  //   }
  // };

  // const handleSubmitForPreview = (e) => {
  //   e.preventDefault();
  //   const currentUrl = window.location.href;
  //   const [partA, partB] = currentUrl.split("/check-detail/");
  //   const [reference, route] = partB.split("/");
  //   navigate(`/case-initiation/profile-preview/${reference}`);
  // };

  // const handleAddedFile = (newData) => {
  //   const [fieldKey, fieldName, fieldIndex = null] = addedFileName.split("-");
  //   const updatedUnsavedData = _.cloneDeep(unsavedNIDDetails);
  //   if (fieldIndex) {
  //     for (var i in updatedUnsavedData.fields[fieldKey][fieldName]) {
  //       if (
  //         updatedUnsavedData.fields[fieldKey][fieldName][i].field_name ===
  //         fieldIndex
  //       ) {
  //         const newVal = newData.fields[fieldKey][fieldName][i].value;
  //         updatedUnsavedData.fields[fieldKey][fieldName][i].value = newVal;
  //       }
  //     }
  //   } else {
  //     for (var i in updatedUnsavedData.fields[fieldKey]) {
  //       if (updatedUnsavedData.fields[fieldKey][i].field_name === fieldName) {
  //         const newVal = newData.fields[fieldKey][i].value;
  //         updatedUnsavedData.fields[fieldKey][i].value = newVal;
  //       }
  //     }
  //   }
  //   setNIDDetails(updatedUnsavedData);
  //   setAddedFileName(null);
  //   createErrorData(updatedUnsavedData);
  //   createDisabledOptions(updatedUnsavedData);
  // };

  // const handleDeletedFile = () => {
  //   const [fieldKey, fieldName, fieldIndex = null] = deletedFileName.split("-");
  //   const updatedUnsavedData = _.cloneDeep(unsavedNIDDetails);
  //   if (fieldIndex) {
  //     for (var i in updatedUnsavedData.fields[fieldKey][fieldName]) {
  //       if (
  //         updatedUnsavedData.fields[fieldKey][fieldName][i].field_name ===
  //         fieldIndex
  //       ) {
  //         updatedUnsavedData.fields[fieldKey][fieldName][i].value = "";
  //       }
  //     }
  //   } else {
  //     for (var i in updatedUnsavedData.fields[fieldKey]) {
  //       if (updatedUnsavedData.fields[fieldKey][i].field_name === fieldName) {
  //         updatedUnsavedData.fields[fieldKey][i].value = "";
  //       }
  //     }
  //   }
  //   setNIDDetails(updatedUnsavedData);
  //   setDeletedFileName(null);
  //   createErrorData(updatedUnsavedData);
  //   createDisabledOptions(updatedUnsavedData);
  // };

  return (
    <>
      {/* <div className="d-flex justify-content-between align-items-center">
        <ul className="nav nav-tabs address-tabs" id="myTab" role="tablist">
          {
            Object.keys(tabs).map((field) => {
              // const index = parseInt(key) + 1;
              // const caseCheckId = value.case_check_id;
              // const caseCheckStatus = value.check_status;
              let activeClass = "";
              if (typeof active !== "undefined") {
                if (selectedField == field) {
                  activeClass = "show active";
                }
              }
              //  else if (index === 1) {
              //  activeClass = "active";
              // }

              let completeClass = "";
              // console.log(caseCheckStatus);
              // if (caseCheckStatus === 2 || caseCheckStatus === 3) {
                // let completeClass = "completed";
              // }

              return (
                <li className={`nav-item ${completeClass}`} >
                  <a
                    className={`tab nav-link ${activeClass} ${completeClass}`}
                    // id={`education-tab-${index}`}
                    data-toggle="tab"
                    // href={`#education-${index}`}
                    role="tab"
                    // aria-controls={`education-${index}`}
                    aria-selected="true"
                    // data-index={index - 1}
                    // data-caseCheckId={caseCheckId}
                    onClick={() => changeTab(field)}
                  >
                    {/* {(caseCheckStatus === 2 || caseCheckStatus === 3) && ( */}
      {/* <i class="fas fa-check-circle mr-1"></i> */}
      {/* )} */}
      {/* {getTabName(field)}
                  </a>
                </li>
              );
            })}
        </ul>
      </div>  */}

      {isLoading && <Loader />}

      <div
        className=""
        style={{
          maxWidth: "100%",
          overflowX: "hidden",
          background: "#F9FAFB",
        }}
      >
        <div className="header border-bottom py-2">
          <div
            className="btn-group p-0 mb-2 d-block pb-2"
            style={{
              borderRadius: "18px !important",
              whiteSpace: "nowrap",
              overflowX: "auto", // Enable horizontal scrolling
              WebkitOverflowScrolling: "touch", // For smooth scrolling on iOS devices
              scrollSnapType: "x proximity", // Snap to nearest button
            }}
            role="group"
            aria-label="Basic example"
          >
            {/* {Object.keys(tabs).map((field) => {

              if(field == "NID_Default_Field"){
                {tabs.NID_Default_Field.map((item,key) => {
                  return(
                    <button
                    type="button"
                    className="btn btn-outline-primary text-dark rounded-right px-3 py-2"
                    onClick={() => changeTab(field,key)}
                    >
                    {getTabName(field,key)}
                    NID24342
                  </button>
                  )
                })}
              }else{              
              return(
                <button
                type="button"
                className="btn btn-outline-primary text-dark rounded-right px-3 py-2"
                onClick={() => changeTab(field)}
                >
                {getTabName(field)}
              </button>
              )
              }
            })} */}
            {Object.keys(tabs).map((field) => {
              // console.log(nidDetailsNew["check_status"][field]);
              if (field === "NID_Default_Field") {
                return tabs[field].map((item, key) => {
                  let tabName = getTabName(field, key);
                  return (
                    <button
                      type="button"
                      style={{
                        backgroundColor: `${
                          tabName == selectedFieldName
                            ? "#EFF8FF"
                            : "transparent"
                        }`,
                        boxShadow: "unset",
                        borderColor: "1px solid #dee2e6",
                      }}
                      className={`btn text-dark px-3 py-2 ${
                        nidDetailsNew?.["check_status"]?.[field]?.[key]
                          ? "completed"
                          : ""
                      } ${tabName == selectedFieldName ? "active" : ""}`}
                      onClick={() => changeTab(field, key + 1)}
                    >
                      {tabName}{" "}
                      {nidDetailsNew?.["check_status"]?.[field]?.[key] ? (
                        <span>
                          <img className="pb-1 ml-1" src={tick} alt="tick" />
                        </span>
                      ) : (
                        ""
                      )}
                    </button>
                  );
                });
              } else {
                return (
                  <button
                    type="button"
                    style={{
                      backgroundColor: `${
                        field == selectedField ? "#edf8ff" : "transparent"
                      }`,
                    }}
                    className={`btn  text-dark px-3 py-2 ${
                      nidDetailsNew?.["check_status"]?.[field]
                        ? "completed"
                        : ""
                    }  ${field == selectedField ? "active" : ""}`}
                    onClick={() => changeTab(field)}
                  >
                    {getTabName(field)}
                    {isOCRFlag && getIsMandatoryFlag(field) ? "*" : ""}{" "}
                    {nidDetailsNew?.["check_status"]?.[field] ? (
                      <span>
                        <img className="pb-1 ml-1" src={tick} alt="tick" />
                      </span>
                    ) : (
                      ""
                    )}
                  </button>
                );
              }
            })}
          </div>
        </div>

        {selectedField != "" && (
          <>
            {
              !isOCRFlag &&
              <div class="mt-3">
                <h3>{selectedFieldName}</h3>
                <p className="supportText">
                  Please upload clear photos of required ID
                </p>
              </div>
            }
            <>
              {
                !isOCRFlag && selectedField == "NID_Default_Field" && (
                  // nidFieldData.map((nidField, key) => {
                  //   return (
                  <NationalIDForm
                    field={nidFieldData}
                    nidAllDetails={nidDetails}
                    // nidOptions={nidDetails.NID_Dropdown}
                    nidOptions={disabledOptionsArray}
                    fieldKey={selectedField}
                    errorData={errorData}
                    key={selectedField}
                    NIDKey={NIDKey}
                    savedData={saveData}
                    removeAllDetails={removeAllDetails}
                    // handleInputChange={handleInputChange}
                    // nidFieldIndex={key}
                    // uploadFile={uploadFile}
                    // disabledOptionsArray={disabledOptionsArray}
                    // handleFileDelete={handleFileDelete}
                    showConfirmedAadhaar={showConfirmedAadhaar}
                    confirmedAadhaar={confirmedAadhaar}
                    confirmedAadhaarError={confirmedAadhaarError}
                    // handleReEnter={handleReEnter}
                  />
                )
                //   );
              }
              {!isOCRFlag && selectedField != "NID_Default_Field" && (
                <NationalIDForm
                  field={nidFieldData}
                  nidAllDetails={nidDetails}
                  nidOptions={nidDetails.Default_Nid_Dropdown}
                  fieldKey={selectedField}
                  errorData={errorData}
                  key={selectedField}
                  savedData={saveData}
                  // NIDKey=''
                  // handleInputChange={handleInputChange}
                  // uploadFile={uploadFile}
                  // handleFileDelete={handleFileDelete}
                />
              )}

              {/* {isOCRFlag ? (
                <NationalIdFormWithOCR
                  field={nidFieldData}
                  nidAllDetails={nidDetails}
                  nidOptions={nidDetails.Default_Nid_Dropdown}
                  fieldKey={selectedField}
                  errorData={errorData}
                  key={selectedField}
                  handleInputChange={handleInputChange}
                  uploadFile={uploadFile}
                  handleFileDelete={handleFileDelete}
                  selectedFieldName={selectedFieldName}
                  ibridgeField={ibridgeField}
                  saveDateInput={saveDateInput}
                  handleContinueRedirection={handleContinueRedirection}
                  getIsMandatoryFlag={getIsMandatoryFlag}
                />
              ) : (
                ""
              )} */}

              {/* <hr /> */}
            </>
          </>
        )}
      </div>
    </>
  );
};

export default NationalIDTab;
